import { post } from '../../api'
import { SimpleApi } from '../../api-action'
import { SupportRequestParams, TradeAccountEnquiryParams } from './types'

export const supportRequestApi = (url: string, params: SupportRequestParams): SimpleApi => post(url, params)
export const submitTradeAccountEnquiry = (url: string, params: TradeAccountEnquiryParams): SimpleApi =>
  post(url, params)
